import { parseUnsignedIntStrict } from "@shared/lib/utils";
import { DocumentItem, DocumentItemAdd } from "../../../../models/document-item";
import { DocumentPaymentForm } from "../../../../models/document-payment";
import { DocumentSettings } from "../../../../models/document-settings";
import { DocumentStructure } from "../../../../models/document-structure";
import { DocumentWork, DocumentWorkAdd } from "../../../../models/document-work";
import { UserData } from "../../../../models/user-data";
import { parseDocumentSettingsIdToNumber as parseDocumentSettingsIdToNumberFromUtils } from "../../utils/documentSettings";

/**
 * Extracts a numeric ID from a pathname like "/a/b/123/..."
 * Throws if the segment is missing or not a valid integer.
 */
export function extractDocumentSettingsId(pathname: string, index: number): number {

  const seg = pathname.split('/').filter(Boolean)[index]; // third segment
  
  if (!seg || !/^\d+$/.test(seg)) {
    throw new Error(`Invalid documentSettingsId in pathname: "${seg}"`);
  }

  const id = Number(seg); // stricter than parseInt (rejects "2a")
  
  // optional extra guard
  if (!Number.isSafeInteger(id)) {
    throw new Error(`documentSettingsId is not a safe integer: ${id}`);
  }
  return id;
}

export function parseDocumentSettingsIdToNumber(id: string | null ): number | null {
  return parseDocumentSettingsIdToNumberFromUtils(id);
}


// ###################################################################################### //
// #                            Memo Functions                                          # //
// ###################################################################################### //


/**
 * Return the document settings match to the document settings id,
 * if not found, return the settings of the first document.
 */
export function getDocumentSettings(documentsSettings?: DocumentSettings[], documentSettingsId?: number | null): DocumentSettings | undefined {

  if(documentsSettings){

    const documentSettingsFound: DocumentSettings | undefined = documentsSettings.find(documentSettings => documentSettings.id === documentSettingsId);
    return documentSettingsFound? documentSettingsFound : documentsSettings[0];
  }
}


/**
 * Returns document structure by adding show_form key to each field, by matching the document settings id.
 * If document settings id not exist, it returns the first document structure.
 */
export function getDocumentStructure(documentsStructure?: DocumentStructure[], documentsSettings?: DocumentSettings[], documentSettingsId?: number | null): DocumentStructure[] | undefined {

  if(documentsStructure && documentsSettings){
      
    const documentStructureCopy = documentsStructure.map(structure => {

      const show_form = structure.show_form_array.find(showForm => showForm.document_settings_id === (documentSettingsId ?? documentsSettings?.[0].id))?.show_form;
      return { ...structure, show_form };
    });

    return documentStructureCopy;
  }
}



// ###################################################################################### //
// #                            forms init functions                                    # //
// ###################################################################################### //


export function getDocumentFormData(state: UserData) {

  const documentData = {
    document_account: state?.document_account,
    car: state?.car,
    reference_id: state?.reference_id,
    reference: state?.reference,
    custom_data: state?.custom_data ?? state?.document?.custom_data,

  };
  

  return documentData;
}


//set the items rows from state
export function getFormWorksRows(state: UserData): DocumentWorkAdd[] {

  const works = state?.works || (state?.document?.works as DocumentWork[])?.map(work => {
    return work.work_id ? { ...work, id: work.work_id } : { ...work, work_id: work.id };
  });

  return works ?? [{
    hours: 1,
    price: 0,
    discount: 0,
    net: 0,
    total: 0,
  }]; 
}


// set the items rows from state
export function getFormItemsRows(state: UserData): DocumentItemAdd[] {

  const items: DocumentItemAdd[] | undefined = state?.items ?? (state?.document?.items as DocumentItem[])?.map(item => {
    return item.item_id ? { ...item, id: item.item_id } : { ...item, item_id: item.id };
  });

  return items ?? [{
    amount: 1,
    price: 0,
    discount: 0,
    net: 0,
    total: 0, 
  }];
}


export function getPaymentsRows(state: UserData): DocumentPaymentForm[] {

  const payments = state?.payments || state?.document?.payments as DocumentPaymentForm[];

  return payments ?? [{
    total: 0,
    // kupa_account_id: 0
    // price: 0,
    // discount: 0,
    // net: 0,
  }];   
}
